export const formatCompletionPercentage = percentage => 
    isNaN(percentage) ? 0 : Math.round(percentage * 100);